//import { required, maxLength } from "vuelidate/lib/validators";
import Pagination from "../../../components/Pagination.vue";
import AIModelService  from "../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../helpers/general";
import { ERRORS_CODE } from "../../../const/error_code";
import { TRAINING_STATUS } from "../../../const/aimodel";
import * as Swal from "sweetalert2";
import LossHistoriesGraph from "./Chart/LossHistoriesGraph.vue"

export default {
    components: {
        appPagination: Pagination,
        LossHistoriesGraph
    },
    data() {
        return {
            page_title: '',
            pagination : {
                currentPage: 1,
                pageCount: 1,
            },
            errors: {},
            aiModel: {
                id: '',
                name: ''
            },
            trainIndex: -1,
            formSubmitted: false,
            record_query: '',
            epochs: 100,
            batch_size: 1000,
            trains: [],
            TRAINING_STATUS: TRAINING_STATUS,
            notify_email: false
        }
    },
    methods: {
        train() {
            Swal.fire({
                text: this.$t("ai_model_train.confirm"),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    return AIModelService.train(this.aiModel.id, this.record_query, this.epochs, this.batch_size, this.notify_email).then((response) => {
                        this.formSubmitted = false;
                        this.getAllTrains(this.aiModel.id);
                        if (response.data.success) {
                            alertResponseSuccess(this.$t("common_message.train_success"));
                        }
                    }).catch((error) => {
                        this.getAllTrains(this.aiModel.id);
                        if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                            alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                        }else if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_TRAINING_ALREADY_STARTED) {
                            alertResponseError(this.$t("message_error.AI_MODEL_TRAINING_ALREADY_STARTED"));
                        }else if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_LAYER_NOT_VALID) {
                            alertResponseError(this.$t("message_error.AI_MODEL_LAYER_NOT_VALID"));
                        } else {
                            return alertResponseError(error.response.data.error);
                        }
                        
                    });
                }
            });
        },
        handleForm() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            return this.train();
        },
        getAllTrains(id) {
            AIModelService.getAllTrains(id, this.pagination.currentPage).then((response) => {
                this.trains = response.data.data.results;
                this.pagination.pageCount = response.data.data.count;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        deleteTrainHistory(trainIndex) {
            Swal.fire({
                text: this.$t("ai_model_train.confirm_delete"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ef8157',
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    AIModelService.deleteTrainHistory(this.aiModel.id, trainIndex).then(() => {
                        this.getAllTrains(this.aiModel.id);
                    }).catch((error) => {
                        if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_TRAIN_NOT_FOUND) {
                            alertResponseError(this.$t("ai_model_train.not_found"));
                        } else {
                            alertResponseError(error);
                        }
                    });
                }
            });

        },
        showLossHistoryGraph(trainIndex) {
            this.trainIndex = trainIndex
            this.$modal.show('loss_histories_modal')            
        },
        // call after LossHistoryGraph showed
        getTrainsLosses() {
            if (this.trainIndex < 0) {
                return
            }

            AIModelService.getTrainsLosses(this.aiModel.id , this.trainIndex).then((response) => {
                if (response.data.success) {
                    this.trainIndex = -1

                    if (response.data.data) {
                        let label_epochs = []
                        let loss_data = []
                        let data = response.data.data
                        for (let i = 0; i < data.length; i++) {
                            label_epochs.push(data[i][0])
                            loss_data.push(data[i][1])
                        }

                        this.$refs.lossLineGraph.updateChart(label_epochs, loss_data)
                  }
                }
            }).catch((error) => {
                this.trainIndex = -1
                alertResponseError(error);
            });
        },
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.page_title = document.title;
        let model = JSON.parse(localStorage.getItem('selected_ai_model'));
        if (!model) {
            this.$router.push({name: 'ai-model-list'});
        }
        this.aiModel.id = model.id;
        this.aiModel.name = model.name;
        this.getAllTrains(this.aiModel.id);
    },
    computed: {
        recordQueryErrorMsg() {
            /*
            if (!this.$v.form.record_query.required) {
                return this.$t('message_error.');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }, 
        epochsErrorMsg() {
            /*
            if (!this.$v.form.epochs.required) {
                return this.$t('message_error.');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }, 
        batchsizeErrorMsg() {
            /*
            if (!this.$v.form.bach_size.required) {
                return this.$t('message_error.');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }, 
    },
    validations() {
        return {
            form: {
                record_query: {  },
                epochs: {  },
                batch_size: {  },
            }
        }
    }
}